<template>
  <v-container>
    <!-- <h2 class="ml-6" style="color: #2C3843">Cuenta Sin Materia</h2> -->
    <v-card elevation="2">

      <DetallesApelacion
        v-if="apelacion"
        :apelacion="apelacion"
        :cuenta="cuenta_detalles"
        :role="roleUser"
        @closeModal="$router.push({ name:'Tocas' })"
      >
      </DetallesApelacion>

      <v-toolbar id="focusOnElement" dense dark color="indigo lighten-1">
        <v-toolbar-title class="text-uppercase">DEJAR SIN MATERIA</v-toolbar-title>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card  class="py-0 mb-0 pt-0"  elevation="2">
        <!-- <v-row > -->
          <v-col cols="12" class="py-2 mb-0 pt-0">
            <div class="mx-4 py-3" style="background-color: #FFFFFF">
              <!-- <v-card class="mx-0" v-if="roleUser == 'Magistrado'"> -->
              <v-card class="mx-0">
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-toolbar
                    color="#E0E0E0"
                    dense
                    flat
                  >
                    <h3 class="font-weight-bold" style="color: #0D47A1">
                      Motivos Sin Materia
                    </h3>
                  </v-toolbar>
                  <v-container class="mt-9" v-if="roleUser == 'magistrado'">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        class="mt-n6"
                      >
                      <vue-editor
                        v-model="observaciones"
                        outlined
                        name="input-7-4"
                        placeholder=""
                        required
                        placeholder="Ingrese los motivos..."
                      ></vue-editor>
                      </v-col>
                    </v-row>
                    <br>
                    <v-btn
                      block
                      dark
                      color="teal"
                      :loading="loading"
                      :disabled="!valid"
                      @click="validate"
                      class="mb-6"
                    >
                      GUARDAR
                      <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                    <!-- <v-divider></v-divider> -->
                  </v-container>
                  </v-form>
                </v-card>
                <br>
            </div>
          </v-col>
        <!-- </v-row> -->
      </v-card>

    </v-card>
  </v-container>
</template>

<script>
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";
  import { mapMutations } from "vuex";
  import { VueEditor } from 'vue2-editor';
  import DetallesApelacion from "../../components/DetallesApelacion";

  export default {
    components: {
       // NewObservacion,
       DetallesApelacion
    },
    props: {
      source: String
    },
    data(){
      return{
        motivos:'',
        valid: false,
        loading: false,
        apelacion: null,
        cuenta_detalles: null,
        cuenta: {},
        active_tab: {},
        htmlForEditor:'',
        observaciones:'',
      }
    },
    computed: {
      formTitle () {
        return 'Add Observación'
      },
      ...mapGetters(["currentUser", "roleUser"]),
    },
    mounted() {
      this.cuenta_id =  JSON.parse(localStorage.getItem("currentCuenta"))
      this.getCuenta()
      setTimeout(function () {
        var element = document.getElementById("focusOnElement");
        window.scrollTo({
          top: element.offsetTop,
          behavior: 'smooth'});
      }.bind(this), 1000);
    },
    methods:{
      getCuenta(){
        this.$store.dispatch("SHOW_CUENTA", {
          url:"/cuenta/"+ this.cuenta_id
        }).then((response) => {
          this.cuenta_detalles = response.data.data.cuenta
          this.apelacion = response.data.data.cuenta.apelacion
        }).catch(err => {
          console.log(err);
        });
      },
      validate() {
        if (this.$refs.form.validate()) {
          // var tocacompleto = this.toca.replace('/','');
          // this.anio = tocacompleto.substr(tocacompleto.length - 4);
          // this.numero = tocacompleto.slice(0, tocacompleto.length - 4);
          this.loading = true;
          this.save();
        }
      },
      save() {
        var data = {
          cuenta_id:this.cuenta_detalles.id,
          observaciones: this.observaciones,
        }
        var url;
        // if (this.roleUser == 'Magistrado') {
          url = '/cuenta/'+this.cuenta_detalles.id+'/sin-materia';
        // }
        // console.log(url);
        this.$store.dispatch("CREATE_OBSERVACION", { url: url, data:data })
        .then(response => {
            this.loading = false;
            if (response.data.status == "ok") {
              this.$swal({
                title: "Éxito!!!",
                text: "Se eliminó la materia correctamente.",
                icon: "success",
                confirmButtonText: "Aceptar"
              });
            //  console.log(response.data.data.cuenta);
            }
            this.$router.push({ name:'Tocas' })
          }).catch(error => {
            console.log(error);
            this.loading = false;
            this.$swal({
              title: "Error",
              text: "No se pudo eliminar la materia",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          });
      },
    }
  }
</script>

<style media="screen">
  .theme--light.v-input input, .theme--light.v-input textarea {
    color: rgb(62 61 61 / 87%);
  }
  .table {
    border-collapse:collapse;
    width: 100%;
  }

  .format_table {
    /* border: 1px solid #dddddd; */
    text-align: left;
    padding: 8px;
  }
</style>
